import { request } from './request';

// 请求零代码资源和类别
export function getThingxType() {
    return request({
        url: '/zeroCode/getZeroType',
		method: 'get',
    });
}

// 请求零代码插件资源
export function postThingxPlugins(param) {
    return request({
        url: '/zeroCode/postPlugins',
		method: 'post',
        data: param
    });
}


// 获取零代码项目资源
export function postThingxProjects(param) {
    return request({
        url: '/zeroCode/postProjects',
		method: 'post',
        data: param
    });
}

// 获取低代码插件资源
export function postLowCodePlugins(param) {
    return request({
        url: '/lowCodePlugin/postLowCodePlugins',
		method: 'post',
        data: param
    });
}



// WEBPACK FOOTER //
// ./src/network/thingxApi.js